import * as Highcharts from 'highcharts/highcharts';
import { plainToClass } from 'class-transformer';
import { Patient, DisplayValues, DropdownOption, Sample, Unit } from './inventory-summary.entities';
import { FormatNumberWithCommas } from '../../../../shared/scripts/number-functions';  
import { BiospecimenInventoryLookup } from './inventory-lookup';
import { DateUpdatedSection } from "../../../../shared/components/date-updated-section/date-updated-section.view";


export class InventorySummaryPage {
    allPatients: Patient[];
    ageRange: number[] = [];
    patientsByVisitChart: any;
    patientsBySampleType: any;
    samplesByVisitChart: any;
    unitsByVisitChart: any;

    ageSlider: any;
    minMaxAge: number[] = [];

    displayData: DisplayValues = new DisplayValues();

    colorArray: string[] = [
        "#013c58",   // Day 0
        "#457b9d",   // Days 1-50
        "#a8e8f9",   // Days 51-75
        "#b5c6e0",   // Days 76-90
        "#fdc500",   // Days 91-168
        "#ffe14c",   // Days 169-336
        "#fff2b2",   // Unscheduled Visit
        //"#95a8b0"    // Unknown (gray)
    ]

    collection_windows: string[] = ["Day0", "Days1to50", "Days51to75", "Days76to90", "Days91to168", "Days169to336", "Unscheduled"]
    totalColorArray: string[] = [];
    nonActiv1ColorArray: string[] = [];

    constructor(data: any, LastUpdatedJson: any) {
        Highcharts.setOptions({
            lang: { thousandsSep: ',' },
            colors: this.colorArray
        });
        $(() => {
            new DateUpdatedSection(LastUpdatedJson, false, false, false, false, false, true);
            //console.log("Received raw data: ",data);

            this.allPatients = plainToClass(Patient, <Patient[]>data);
            this.allPatients.map((patient: Patient) => {
                patient.initialize();
                return patient;
            });

            //console.log("All patients loaded from JSON:", this.allPatients);
            this.initializeColorArrays();
            this.initializeFilters();

            this.initializeParticipantsByVisitChart();
            this.initializeParticipantsBySampleTypeChart();
            this.samplesByVisitChart = this.initializeSamplesandUnitsByVisitChart('samples-byvisit-chart', 'Unique Collection');
            this.unitsByVisitChart = this.initializeSamplesandUnitsByVisitChart('units-byvisit-chart', 'Resulting Sample');

            this.updateDisplay();

            $(".modal").on("shown.bs.modal", (e: Event) => {
                let targetElement = $(e.target).find(".scroll-modal-body");
                targetElement.animate({
                    scrollTop: 0
                }, 250)
            });
            $('#loading-indicator').hide();
            $('.loaded-content').removeClass('invisible');
        })
    }

    initializeColorArrays(): void {
        let colorCount = 0;
        for (let i = 0; i < this.collection_windows.length; i++) {
            this.totalColorArray.push(this.colorArray[colorCount]);
            colorCount++;
            if (colorCount >= this.colorArray.length) {
                colorCount = 0;
            }
        }
    }

    reorderedData(originalData: number[]): number[] {
        const originalOrder = BiospecimenInventoryLookup.SAMPLE_TYPES;
        const alphabeticalOrder = BiospecimenInventoryLookup.GetAlphabeticalSampleTypes();
        return alphabeticalOrder.map(sampleType => {
            const originalIdx = originalOrder.indexOf(sampleType);
            return originalData[originalIdx] ?? 0;
        });
    }

    updateDisplay(): void {
        let trialValues: string[] = <string[]>$('#trial-dropdown').val();

        this.displayData.Update(this.allPatients, trialValues, <string[]>($('#recovercohort-dropdown').val()), <string[]>($('#specimen-status-dropdown').val()), <string[]>($('#age-dropdown').val()), <string[]>($('#sex-dropdown').val()), <string[]>($('#race-dropdown').val()), <string[]>($('#ethnicity-dropdown').val())); 

        $('#value-total-participants').text(FormatNumberWithCommas(this.displayData.ParticipantCount + ""));
        $('#value-total-samples').text(FormatNumberWithCommas(this.displayData.SampleCount + ""));
        $('#value-total-units').text(FormatNumberWithCommas(this.displayData.UnitCount + ""));

        let patientsByVisitData: number[] = [];
        for (let i = 0; i < this.collection_windows.length; i++) {
            patientsByVisitData.push(this.displayData[`Participants_Visit${this.collection_windows[i]}`])
        }
        this.patientsByVisitChart.series[0].setData(patientsByVisitData);

        this.patientsBySampleType.series[5].setData(this.reorderedData(this.displayData.Participants_Timepoint1.GetDataArray()), false, true, false);
        this.patientsBySampleType.series[4].setData(this.reorderedData(this.displayData.Participants_Timepoint2.GetDataArray()), false, true, false);
        this.patientsBySampleType.series[3].setData(this.reorderedData(this.displayData.Participants_Timepoint3.GetDataArray()), false, true, false);
        this.patientsBySampleType.series[2].setData(this.reorderedData(this.displayData.Participants_Timepoint4.GetDataArray()), false, true, false);
        this.patientsBySampleType.series[1].setData(this.reorderedData(this.displayData.Participants_Timepoint5.GetDataArray()), false, true, false);
        this.patientsBySampleType.series[0].setData(this.reorderedData(this.displayData.Participants_Timepoint6.GetDataArray()), false, true, false);
        //this.patientsBySampleType.series[2].setData(this.displayData.Participants_Timepoint6.GetDataArray(), false, true, false);
        //this.patientsBySampleType.series[1].setData(this.displayData.Participants_Timepoint7.GetDataArray(), false, true, false);
        //this.patientsBySampleType.series[0].setData(this.displayData.Participants_Timepoint8.GetDataArray(), false, true, false);
        this.patientsBySampleType.redraw();


        for (let i = 0; i < this.collection_windows.length; i++) {
            this.samplesByVisitChart.series[i].setData(
                this.reorderedData(this.displayData[`Samples_Visit${this.collection_windows[i]}`].GetDataArray()), false, true, false);
                console.log(this.reorderedData(this.displayData[`Samples_Visit${this.collection_windows[i]}`].GetDataArray()), false, true, false);
        }

        this.samplesByVisitChart.redraw();

        for (let i = 0; i < this.collection_windows.length; i++) {
            this.unitsByVisitChart.series[i].setData(
                this.reorderedData(this.displayData[`Units_Visit${this.collection_windows[i]}`].GetDataArray()), false, true, false);
        }

        this.unitsByVisitChart.redraw();
    }

    initializeFilters(): void {
        let trials: DropdownOption[] = []; let trialIds: number[] = [];
        let recovercohort: DropdownOption[] = []; let recovercohortId: number[] = [];
        let specimenStatuses: DropdownOption[] = []; let specimenStatusIds: number[] = [];
        let sexes: DropdownOption[] = []; let sexIds: number[] = [];
        let races: DropdownOption[] = []; let raceIds: number[] = [];
        let ages: DropdownOption[] = []; let ageIds: number[] = [];
        let ethnicities: DropdownOption[] = []; let ethnicityIds: number[] = [];

        this.allPatients.forEach((patient: Patient) => {
            if (!trialIds.includes(patient.AppendixId)) { trials.push(new DropdownOption(patient.AppendixId, 'trial')); trialIds.push(patient.AppendixId); }
            if (!recovercohortId.includes(patient.RecoverCohortId)) { recovercohort.push(new DropdownOption(patient.RecoverCohortId, 'recover-cohort')); recovercohortId.push(patient.RecoverCohortId); }
            if (!sexIds.includes(patient.SexId)) { sexes.push(new DropdownOption(patient.SexId, 'sex')); sexIds.push(patient.SexId); }
            if (!raceIds.includes(patient.RaceId)) { races.push(new DropdownOption(patient.RaceId, 'race')); raceIds.push(patient.RaceId); }
            if (!ageIds.includes(patient.AgeId)) { ages.push(new DropdownOption(patient.AgeId, 'age')); ageIds.push(patient.AgeId); }
            if (!ethnicityIds.includes(patient.EthnicityId)) { ethnicities.push(new DropdownOption(patient.EthnicityId, 'ethnicity')); ethnicityIds.push(patient.EthnicityId); }

            patient.Samples.forEach((sample: Sample) => {
                sample.Units.forEach((unit: Unit) => {
                    if (!specimenStatusIds.includes(unit.Status)) { specimenStatuses.push(new DropdownOption(unit.Status, 'specimen-status')); specimenStatusIds.push(unit.Status); }
                });
            });
        });
        const trialSortOrder: { [key: string]: number } = {
            "AUTONOMIC (Overall)": 0,
            "AUTONOMIC-1 (IVIG)": 1,
            "AUTONOMIC-2 (Ivabradine)": 2,
            "AUTONOMIC (Unassigned)": 3,
            "ENERGIZE (Overall)": 4,
            "ENERGIZE-1 (Cardiopulmonary Rehab)": 5,
            "ENERGIZE-2 (Structured Pacing)": 6,
            "ENERGIZE (Unassigned)": 7,
            "NEURO (Overall)": 8,
            "NEURO-1 (tDCS & BrainHQ)": 9,
            "NEURO (Unassigned)": 10,
            "SLEEP (Overall)": 11,
            "SLEEP-1 (Modafinil/Solriamfetol)": 12,
            "SLEEP-2 (Melatonin/Light)": 13,
            "SLEEP (Unassigned)": 14,
            "VITAL (Overall)": 15,
            "VITAL-1 (Paxlovid)": 16,
            "VITAL (Unassigned)": 17
        };

        function dropdownValuesSort(options: DropdownOption[], order?: string[], isTrial?: boolean) {
            if (order) {
                options.sort((a, b) => order.indexOf(a.Value) - order.indexOf(b.Value));
            } else if (isTrial) {
                options.sort((a, b) => {
                    const aOrder = trialSortOrder[a.Value] ?? Number.MAX_SAFE_INTEGER;
                    const bOrder = trialSortOrder[b.Value] ?? Number.MAX_SAFE_INTEGER;
                    return aOrder - bOrder;
                });
            }
            return options
        }
        const dropdowns = [
            { id: "#age-dropdown", options: ages, order: ["18 - 45", "46 - 65", ">65", "Unknown"] },
            { id: "#trial-dropdown", options: trials, isTrial: true },
            { id: "#recovercohort-dropdown", options: recovercohort, order: ["Yes", "No", "Unknown"] },
            { id: "#specimen-status-dropdown", options: specimenStatuses },
            { id: "#sex-dropdown", options: sexes, order: ["Female", "Male", "Intersex", "Prefer Not To Answer", "Unknown"] },
            { id: "#race-dropdown", options: races, order: ["American Indian or Alaska Native", "Asian", "Black", "Middle East or North Africa", "Native Hawaiian or Pacific Islanders", "White", "Multi-Racial", "Unknown"] },
            { id: "#ethnicity-dropdown", options: ethnicities, order: ["Hispanic", "Not Hispanic", "Unknown"] }
        ];
        dropdowns.forEach(d => {
            dropdownValuesSort(d.options, d.order, d.isTrial);
            this.initializeDropdown(d.id, d.options);
        })
    }

    initializeDropdown(dropdownId: string, entries: DropdownOption[]): void {

        //console.log(entries);

        $(dropdownId).selectpicker({
            dropupAuto: false,
            //actionsBox: true,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) { return "All   (n = " + numSelected + ")"; }
                else { return numSelected + " of " + numTotal + " Selected"; }
            }
        });

        $(dropdownId).on('changed.bs.select', (e, clickedIndex, isSelected, previousValue) => { this.updateDisplay(); });

        //entries.sort((a, b) => (a.Value > b.Value) ? 1 : -1);

        entries.forEach((element: DropdownOption) => {
            let option: any = new Option(element.Value, element.Id + "", false, true);
            $(dropdownId).append(option);
        });
        $(dropdownId).selectpicker("refresh");

    }

    initializeParticipantsByVisitChart(): void {
        this.patientsByVisitChart = Highcharts.chart({
            chart: {
                renderTo: 'participants-byvisit-chart', 
                type: 'bar',
                colorCount: 6,
            },
            colors: this.colorArray,
            credits: { enabled: false },
            title: { text: null },
            legend: { enabled: false },
            xAxis: {
                categories: ["Day 0",
                    "Days 1-50",
                    "Days 51-75",
                    "Days 76-90",
                    "Days 91-168",
                    "Days 169-336",
                    "Unscheduled"],
                    //"Unknown"],
                reversed: true,
                tickInterval: 1,
                tickLength: 0,
                min: 0,
                labels: {
                    align: "left",
                    reserveSpace: true
                },
                title: { text: 'Collection Windows' },
            },
            yAxis: {
                min: 0,
                endOnTick: false, 
                maxPadding: 0.2,
                title: {
                    text: 'Participant Count'
                },
                labels: {
                    formatter: function () {
                        return Highcharts.numberFormat(this.value, 0, '.', ',');
                    }
                }
            },
            tooltip: {  
                enabled: true,  
                borderColor: "black",  
                useHTML: true,  
                formatter: function () {  
                    const xValue = String(this.x); 
                    return `<b>${xValue.replace("<br>", " ")}</b><br/><div class="text-center">${Highcharts.numberFormat(this.y, 0, '.', ',')}</div>`;  
                }  
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                },
                bar: {
                    colorByPoint: true,
                    dataLabels: {
                        enabled: true,
                        crop: false,
                        overflow: 'justify',
                        format: undefined,
                        allowOverlap: true,
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 0, '.', ',');
                        }
                    }
                }
            },
            series: [{
                type: 'bar',
                data: new Array(this.collection_windows.length).fill(0)
            }]
        })
    }

    initializeParticipantsBySampleTypeChart(): void {
        //const categories = BiospecimenInventoryLookup.SAMPLE_TYPES;
        const categories = BiospecimenInventoryLookup.GetAlphabeticalSampleTypes();
        const seriesData: Highcharts.SeriesBarOptions[] = [];
        for (let n = 6; n >= 1; n--) {
            const dataArray: number[] = this.displayData[`Participants_Timepoint${n}`].GetDataArray();
            const reorderedData = this.reorderedData(dataArray);
            seriesData.push({
                type: 'bar',
                name: `${n}`,
                data: dataArray,
                color: this.colorArray[n - 1],
            });
        }

        this.patientsBySampleType = Highcharts.chart(
            'participants-bysampletype-chart',
            {
                chart: {
                    type: 'bar',
                },
                credits: { enabled: false },
                title: { text: null },
                xAxis: {
                    type: 'category',
                    categories: categories,
                    title: { text: 'Biospecimen Types' },
                    min: 0,
                    max: categories.length - 1,
                    tickInterval: 1,
                    tickLength: 0,
                    labels: {
                        align: 'left',
                        reserveSpace: true
                    }
                },

                yAxis: {
                    min: 0,
                    endOnTick: false, // helps with cropping data labels
                    maxPadding: 0.2,
                    title: { text: 'Participant Count' },
                    labels: {
                        formatter: function () {
                            return Highcharts.numberFormat(this.value as number, 0, '.', ',');
                        },
                        rotation: 0,
                    },
                    stackLabels: {
                        enabled: true,
                        formatter: function () {
                            return Highcharts.numberFormat((this as any).total as number, 0, '.', ',');
                        }
                    }
                },

                legend: {
                    reversed: true,
                    title: {
                        text:
                            '<div style="font-size: 10px; color: #666; font-weight: normal; width: 100%; text-align: center">Number of Unique Collection Windows</div>'
                    },
                    align: 'center',
                    verticalAlign: 'top'
                },
                plotOptions: {
                    series: {
                        stacking: 'normal' 
                    },
                    bar: {
                        pointPadding: 0.2,
                        borderWidth: 0,
                        dataLabels: {
                            enabled: false
                        }
                    }
                },
                series: seriesData
            } 
        )
    }

    initializeSamplesandUnitsByVisitChart(chartId: string, label: string): any {
        let chart: any = Highcharts.chart({
            chart: {
                renderTo: chartId,
                type: 'bar',
                //styledMode: true,
                colorCount: 12,
            },
            credits: { enabled: false },
            title: { text: null },
            xAxis: {
                type: 'category',
                categories: BiospecimenInventoryLookup.GetAlphabeticalSampleTypes(),
                title: { text: 'Biospecimen Types' },
                min: 0,
                max: BiospecimenInventoryLookup.GetAlphabeticalSampleTypes().length - 1,
                tickInterval: 1,
                tickLength: 0,
                labels: {
                    align: "left",
                    reserveSpace: true
                },
            },
            yAxis: {
                min: 0,
                endOnTick: false, // helps with cropping data labels
                maxPadding: 0.2, // larger value has more space for data labels (default is 0.05)
                reversedStacks: false,
                title: { text: label + ' Count' },
                labels: {
                    formatter: function () {
                        return Highcharts.numberFormat(this.value, 0, '.', ',');
                    }
                },
                stackLabels: {
                    enabled: true,
                    formatter: function () {
                        return Highcharts.numberFormat(this.total, 0, '.', ',');
                    }
                }
            },
            legend: {
                enabled: false,
                reversed: false,
                title: {
                    text: '<div style="font-size: 10px; color: #666; font-weight: normal; width: 100%; text-align: center">Visits</span>',
                },
                align: 'center',
                verticalAlign: 'bottom',
            },
            plotOptions: {
                series: {
                    stacking: 'normal'
                },
                bar: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                    dataLabels: { enabled: false },
                },
            },
            series: [
                { type: 'bar', name: 'Day 0', data: [], color: this.colorArray[0] },
                { type: 'bar', name: 'Days 1-50', data: [], color: this.colorArray[1] },
                { type: 'bar', name: 'Days 51-75', data: [], color: this.colorArray[2] },
                { type: 'bar', name: 'Days 76-90', data: [], color: this.colorArray[3] },
                { type: 'bar', name: 'Days 91-168', data: [], color: this.colorArray[4] },
                { type: 'bar', name: 'Days 169-336', data: [], color: this.colorArray[5] },
                { type: 'bar', name: 'Unscheduled', data: [], color: this.colorArray[6] },
                //{ type: 'bar', name: 'Unknown', data: [], color: this.colorArray[7] }
            ]

        });
        return chart;
    }

    clickedSampleTypeByVisitChartLegend(index: number): void {

        if (this.samplesByVisitChart.series[index].visible) {
            this.samplesByVisitChart.series[index].hide();
            this.unitsByVisitChart.series[index].hide();
            $('.item' + index).addClass('inactive');
        }
        else {
            this.samplesByVisitChart.series[index].show();
            this.unitsByVisitChart.series[index].show();
            $('.item' + index).removeClass('inactive');
        }
    }

    resetFilters(): void {
        //$('#includeMissingAgeCheckbox').is(":checked")

        ['#trial-dropdown', '#recovercohort-dropdown', '#specimen-status-dropdown', '#sex-dropdown', '#race-dropdown', '#ethnicity-dropdown', '#age-dropdown'].forEach((dropdownId: string) => {
            $(dropdownId).selectpicker('selectAll');
            $(dropdownId).selectpicker('refresh');
        });

        this.updateDisplay();
    }
}

